import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useCallback, type FC } from 'react';
import useUsersListParams from '../hooks/useUsersListParams';
import type { SortValue } from '../types';

const UsersTableHead: FC = () => {
  const { desc, setDesc, orderBy, setOrderBy } = useUsersListParams();

  const handleToggleSort = useCallback(
    (id: SortValue) => {
      if (id === orderBy) setDesc((prevState) => !prevState);
      else {
        setOrderBy(id);
        setDesc(true);
      }
    },
    [orderBy, setOrderBy, setDesc]
  );

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ minWidth: 200, width: 500 }} style={{ paddingLeft: '4px' }}>
          <TableSortLabel
            active={orderBy === 'email'}
            direction={desc ? 'desc' : 'asc'}
            onClick={() => {
              handleToggleSort('email');
            }}
          >
            Email
          </TableSortLabel>
        </TableCell>
        <TableCell sx={{ minWidth: 200, width: 300 }}>
          <TableSortLabel
            active={orderBy === 'role'}
            direction={desc ? 'desc' : 'asc'}
            onClick={() => {
              handleToggleSort('role');
            }}
          >
            Access level
          </TableSortLabel>
        </TableCell>
        <TableCell sx={{ minWidth: 200 }}>Project</TableCell>
        <TableCell sx={{ minWidth: 200 }}></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default UsersTableHead;
